import {
  types,
  PublishedGraphicActionsType,
  IPublishedGraphic,
} from '../types/publishedGraphic'

export const initialState: IPublishedGraphic = {
  isLoading: false,
  group: '',
  id: '',
  internalId: '',
  internalPackId: '',
  title: '',
  slugline: '',
  description: '',
  byline: '',
  topicCodes: [],
  previewImageURI: '',
  publishedDate: '',
  lastPublishedDate: '',
  shortURI: '',
  thumbnailURI: '',
  graphicType: '',
  graphicSubType: '',
  language: null,
  location: {
    rcsId: '',
    shortName: '',
    n2000: [],
  },
  mediaType: '',
  mimeType: '',
  publishing: { locations: [] },
}

export const publishedGraphic = (
  state = initialState,
  action: PublishedGraphicActionsType
): IPublishedGraphic => {
  switch (action.type) {
    case types.GET_PUBLISHED_GRAPHIC_BY_ID__STARTED:
      return { ...state, isLoading: true }
    case types.GET_PUBLISHED_GRAPHIC_BY_ID__SUCCESS:
      return { ...action.publishedGraphicData, isLoading: false }
    case types.GET_PUBLISHED_GRAPHIC_BY_ID__FAILURE:
      return { ...state, isLoading: false }
    default:
      return state
  }
}
